import Vue from 'vue';

const aboveContent = Vue.component('fl-above-content', {
    template: '<div class="fl-as-above-content fl-w-100"></div>',
});

export default aboveContent;
